import React, { useState } from 'react';
import './ContactFormModal.css';

const ContactFormModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  if (!show) {
    return null;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setAlert({ show: false, type: '', message: '' });

    const form = e.target;
    const formDataToSend = new FormData(form);

    try {
      await fetch('https://formkeep.com/f/85f9d0311fa7', {
        method: 'POST',
        body: formDataToSend,
        headers: {
          'Accept': 'application/json',
        },
      });

      setFormData({ name: '', email: '', message: '' });
      setIsSubmitting(false);
      
      setAlert({
        show: true,
        type: 'success',
        message: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.'
      });

      setTimeout(() => {
        setAlert({ show: false, type: '', message: '' });
        onClose();
      }, 3000);
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
      
      setAlert({
        show: true,
        type: 'error',
        message: 'There was an error submitting the form. Please try again.'
      });

      setTimeout(() => {
        setAlert({ show: false, type: '', message: '' });
      }, 5000);
    }
  };

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="contact-modal-close">
          &times;
        </button>

        {alert.show && (
          <div className={`custom-alert custom-alert-${alert.type}`}>
            <div className="alert-content">
              <span className="alert-icon">
                {alert.type === 'success' ? '✓' : '⚠'}
              </span>
              <span className="alert-message">{alert.message}</span>
            </div>
          </div>
        )}
        
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">Talk to an Expert</h2>
          <p className="contact-modal-subtitle">
            Fill out the form below and we'll get back to you shortly.
          </p>
        </div>

        <form 
          className="needs-validation" 
          noValidate
          onSubmit={handleSubmit}
          action="https://formkeep.com/f/85f9d0311fa7" 
          acceptCharset="UTF-8" 
          encType="multipart/form-data" 
          method="POST"
        >
          <div className="row g-4">
            <div className="col-sm-6">
              <label htmlFor="modal-name" className="form-label fs-base">Full name</label>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                id="modal-name" 
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">Please enter your full name!</div>
            </div>
            <div className="col-sm-6">
              <label htmlFor="modal-email" className="form-label fs-base">Email</label>
              <input 
                type="email" 
                className="form-control form-control-lg" 
                id="modal-email" 
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">Please provide a valid email address!</div>
            </div>
            <div className="col-12 pb-2">
              <label htmlFor="modal-message" className="form-label fs-base">Message</label>
              <textarea 
                className="form-control form-control-lg" 
                id="modal-message" 
                name="message"
                rows="3"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <div className="invalid-feedback">Please enter your message!</div>
            </div>
            <div className="col-12">
              <button 
                type="submit" 
                className="btn btn-lg btn-primary w-100 w-sm-auto"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Submit message'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactFormModal;
